<!-- eslint-disable max-len -->
<template>
  <Stack class="completion-and-thanks">
    <Stack
      class="completion-content"
      items="center"
    >
      <Stack
        gap="4"
        items="center"
      >
        <Icon
          class="success-icon"
          icon="fas fa-check-circle"
          size="8"
        />

        <Title
          class="success-title"
          size="8"
        >
          All Documents Submitted!
        </Title>
      </Stack>

      <p class="success-message">
        Congratulations! You've successfully uploaded all the required documents.
        Your financial advisor <strong>{{ clientPortalStore.advisorName }}</strong> will review them and get back to you soon.
      </p>

      <!-- TODO: COMMENTED OUT BC ITS BROKEN, NEED TO FIX LOGIC -->
      <!-- <div class="completion-stats">
        <div class="stat-item">
          <Title class="stat-number">
            {{ clientPortalStore.totalDocuments }}
          </Title>
          <div class="stat-label">
            Documents Processed
          </div>
        </div>
        <div class="stat-divider" />
        <div class="stat-item">
          <Title class="stat-number">
            100%
          </Title>
          <div class="stat-label">
            Complete
          </div>
        </div>
      </div> -->

      <Stack
        gap="4"
        class="text-items"
      >
        <div class="text-item">
          <Icon
            class="text-icon"
            icon="fas fa-shield-alt"
            size="4"
          />
          <div class="item-body">
            <p>Your documents are securely stored and encrypted. Only you and your advisor have access to them.</p>
          </div>
        </div>

        <div class="text-item">
          <Icon
            class="text-icon"
            icon="fas fa-hand-point-right"
            size="4"
          />
          <div class="item-body">
            <h3>
              What happens next?
            </h3>

            <ul>
              <li>Your advisor will receive a notification about your submissions</li>
              <li>Documents will be reviewed within 1-2 business days</li>
              <li>You'll receive an email with next steps or any follow-up questions</li>
            </ul>
          </div>
        </div>

        <div class="text-item">
          <Icon
            class="text-icon"
            icon="fas fa-question"
            size="4"
          />
          <div class="item-body">
            <p>Questions?</p>

            <p>
              If you have any questions or need to upload additional documents,
              don't hesitate to contact your
              <span v-if="clientPortalStore.advisorInfo?.email">
                advisor at <a :href="mailto">{{ clientPortalStore.advisorInfo.email }}</a>.
              </span>
              <span v-else>
                advisor.
              </span>
            </p>
          </div>
        </div>
      </Stack>

      <Buttons justify="center">
        <Button
          @click="handleClose"
          icon-before="fas fa-times"
        >
          Close this window
        </Button>

        <Button
          @click="clientPortalStore.moveToStart()"
          icon-before="fas fa-home"
        >
          Back to Portal
        </Button>
      </Buttons>
    </Stack>
  </Stack>
</template>

<script setup>
import { computed } from 'vue';
import { Button, Buttons, Icon, Stack, Title } from '@stakeui';
import { useClientPortalStore } from '@frontend/ui/stores/clientPortalStore';

const emit = defineEmits(['back-to-main']);

const clientPortalStore = useClientPortalStore();

const mailto = computed(() => `mailto:${clientPortalStore.advisorInfo?.email}`);

const handleClose = () => {
  window.close();
}
</script>

<style scoped>
.completion-and-thanks {
  background-color: #fff;
  max-width: 60rem;
  margin: 0 auto;
  text-align: center;
  padding: 4em 3em;
  border-radius: 2em;
  box-shadow: 0px 32px 32px 0px rgba(0, 0, 0, 0.02), 0px 16px 16px 0px rgba(0, 0, 0, 0.02), 0px 8px 8px 0px rgba(0, 0, 0, 0.02), 0px 4px 4px 0px rgba(0, 0, 0, 0.02), 0px 2px 2px 0px rgba(0, 0, 0, 0.02), 0px 1px 1px 0px rgba(0, 0, 0, 0.02);
}

.success-icon {
  color: var(--stk-success-50);
}

.success-message {
  max-width: 30em;
  font-size: 1.25em;
}

.completion-stats {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.stat-number {
  color: var(--stk-success-40);
}

.text-items {
  padding: 2em 2em 0;
}

.text-item {
  color: var(--stk-text-50);
  display: flex;
  gap: 0.25em;
  text-align: start;
  flex-grow: 1;
  gap: 0.5rem;
}

.text-icon {
  margin-top: 0.125rem;
  opacity: 0.7;
}
</style>
